export default __webpack_public_path__ + "static/media/dollar.33b282f0.svg";